import { markRaw } from 'vue'

/**
 * Marca cada item de um array como "raw" para evitar que o Vue 3 crie Proxies profundos.
 * Diferente de Object.freeze, markRaw não impede mutação — apenas diz ao Vue para
 * não rastrear as propriedades internas do objeto.
 *
 * Isso mantém compatibilidade com os seletores, que precisam receber objetos sem
 * proxies profundos e sem bloqueio por Object.freeze.
 *
 * O array em si continua reativo — adicionar/remover itens dispara atualizações normalmente.
 */
export function freezeItems (items) {
  if (!Array.isArray(items)) return items
  return items.map(item => markRaw(item))
}
